module.exports = __webpack_public_path__ + "static/media/financeTermIco_Selected.1dab2f4e.svg";